import { api } from './ApiService';

export const getScoreList = () => {
  return api.get('/scoreitems');
};
